module.exports = __webpack_public_path__ + "media/img/frontend_application/bell-dc21bffd44812745bb6e0adb895e4e24.png";